import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0314',
    ecrans: ['00-2'],
    params: ['alicleint']
});
